// extracted by mini-css-extract-plugin
module.exports = {"module":"styles_module__1d2aP","moduleTitle":"styles_moduleTitle__2AVyh","editIcon":"styles_editIcon__3OAkd","moduleContent":"styles_moduleContent__1zRYd"};